import { defineComponent as _defineComponent } from 'vue'
import { useDonationFormsStore } from '../../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'DonationInfo',
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();

const __returned__ = { store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})